export default "__VITE_ASSET__346e08a6__"